import styled from 'styled-components';

export const Content = styled.div`
  width: 75%;
  text-align: center;
  margin: 0 auto;
  @media (min-width: 577px) and (max-width: 1024px){
    width: 100%;
    padding: 0 5% !important;
  }
  @media (max-width: 576px) {
    width: 100%;
    padding: 0 !important;
    label {
      font-size: 0.9rem;
    }
  }
`;